interface AvatarProps {
  name: string
  avatarUrl: string | null
  size?: 'sm' | 'md'
}

/** "Nada por debajo de 12px" (CLAUDE.md §6): el círculo se dimensiona para la tipografía, no al revés. */
const SIZE_CLASSES: Record<NonNullable<AvatarProps['size']>, string> = {
  sm: 'h-5 w-5 text-meta',
  md: 'h-7 w-7 text-meta',
}

/**
 * El modelo de usuario lleva `avatarUrl` (CLAUDE.md §1): el hueco existe aquí
 * ya, aunque hoy la interfaz siempre pinta la inicial porque nadie tiene
 * avatar todavía.
 */
export function Avatar({ name, avatarUrl, size = 'sm' }: AvatarProps) {
  const initial = name.trim().charAt(0).toUpperCase() || '?'

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        className={`${SIZE_CLASSES[size]} shrink-0 rounded-full object-cover`}
      />
    )
  }

  return (
    <span
      aria-hidden="true"
      className={`${SIZE_CLASSES[size]} flex shrink-0 items-center justify-center rounded-full bg-surface-hi font-medium text-text-muted`}
    >
      {initial}
    </span>
  )
}
